module.exports = __webpack_public_path__ + "img/trash.160ab7e9.svg";